import React, { PureComponent } from "react";
import ReactWOW from "react-wow";

class Logo extends PureComponent {
  render() {
    let img = <p className="no-logo">{this.props.name}</p>;
    if (this.props.image) {
      img = (
        <img
          src={"images/partners/" + this.props.image}
          alt={this.props.name}
          className={"img-logo " + (this.props.className || "")}
        />
      );
    }
    return (
      <ReactWOW animation="fadeInUp" delay="0.1s">
        <div className={"col-md-3 col-6 logo " + (this.props.className || "")}>
          <a
            href={this.props.link}
            target="_blank"
            rel="noopener noreferrer"
            className="link"
          >
            {img}

            <p className="name">{this.props.name}</p>
          </a>
        </div>
      </ReactWOW>
    );
  }
}

const Partners = () => (
  <section id="partners" className="white">
    <div className="container">
      <div className="section-title">
        <h2>Partners</h2>
      </div>
      <h2>Organized by</h2>
      <div className="row justify-content-center">
        <div className="col-md-4 col-6 shopee">
          <a
            href="https://careers.shopee.sg/"
            target="_blank"
            rel="noopener noreferrer"
            className="link"
          >
            <img
              src="images/partners/shopee_logo_en.png"
              alt="shopee"
              className="img-logo shopee"
            />
            <p className="name">Shopee</p>
          </a>
        </div>
      </div>
      <h2>Government Partner</h2>
      <div className="row justify-content-center">
        <Logo
          name="Digital Industry Singapore (DISG)"
          image="disg-logo.png"
          link="https://www.imda.gov.sg/for-industry/Digital-Industry-Singapore-DISG"
        />
      </div>

      {/* <h5>Training Partner</h5>
      <div className="row justify-content-center">
        <Logo
          name="YiDu AI"
          image="yidu-ai-logo.png"
          link="https://yiduai.sg/"
        />
        <Logo
          name="Coding Lab"
          image="coding-lab-logo.png"
          link="https://www.codinglab.com.sg/"
        />
        <Logo
          name="Lithan Academy"
          image="lithan-academy-logo.jpg"
          link="https://www.lithan.com/singapore/"
        />
        <Logo
          name="UpLevel"
          image="uplevel-logo.png"
          link="https://discover.uplevel.work/"
        />
      </div> */}
      <h2>University and Academic Partners</h2>
      <div className="row">
        {/* <Logo
          name="Dunman High"
          image="dunman.png"
          link="https://dunmanhigh.moe.edu.sg/"
        />
        <Logo
          name="INSEAD"
          image="insead-logo.png"
          link="https://www.insead.edu/master-programmes"
        />
        <Logo
          name="Kaplan Singapore"
          image="kaplan-logo.png"
          link="https://www.kaplan.com.sg/"
        />
        <Logo
          name="National Junior College"
          image="national-junior-college-logo.png"
          link="https://nationaljc.moe.edu.sg/"
        />
        <Logo
          name="Ngee Ann Poly"
          image="ngee-ann-poly.png"
          link="https://www.np.edu.sg/Pages/default.aspx"
        />
      */}
        <Logo
          name="Nanyang Technological University- Career & Attachment Office"
          image="ntu-cao-logo.png"
          link="https://www.ntu.edu.sg/cao/Pages/index.aspx"
          className="university"
        />
        <Logo
          name="NTU School of Computer Science & Engineering"
          image="ntu-school-computer-science-engineering-logo.png"
          link="http://scse.ntu.edu.sg/Pages/Home.aspx"
          className="university"
        />
        <Logo
          name="NUS Centre for Future-ready Graduates"
          image="nus-graduates.png"
          link="http://nus.edu.sg/cfg/"
          className="university"
        />

        <Logo
          name="SIT"
          image="sit_logo.png"
          link="https://www.singaporetech.edu.sg/"
          className="university"
        />
        {/* <Logo
          name="NUS Enterprise"
          image="nus-enterprise-logo.png"
          link="https://enterprise.nus.edu.sg/"
        /> */}

        {/* <Logo
          name="PolyFinTech"
          image="polyfintech-100-logo.png"
          link="http://www.polyfintech100.sg/"
        />
        <Logo
          name="PSB Academy"
          image="psb_logo.png"
          link="https://www.psb-academy.edu.sg/"
        />
        <Logo
          name="SIM GE"
          image="simge_logo.jpg"
          link="https://www.simge.edu.sg/"
        />
        <Logo
          name="Singapore Polytechnic"
          image="singapore-polytechnic.jpg"
          link="https://www.sp.edu.sg/"
        />
      */}
        <Logo
          name="SUSS"
          image="suss_logo.jpg"
          link="https://www.suss.edu.sg/"
          className="university"
        />
        <Logo
          name="SUTD"
          image="sutd_logo.png"
          link="https://www.sutd.edu.sg/"
          className="university"
        />
        {/* 
        <Logo
          name="Temasek Poly"
          image="temasek_polytechnic_logo.jpg"
          link="https://www.tp.edu.sg/"
        />
        <Logo
          name="Yale NUS"
          image="yale-nus-logo.png"
          link="https://www.yale-nus.edu.sg/"
        />
        <Logo
          name="Republic Polytechnic"
          image="republic-polytechnic-logo.png"
          link="https://www.rp.edu.sg/"
        /> */}
      </div>
      {/* <h5>Partners in Diversity</h5>
      <div className="row">
        <Logo
          name="Coding Girls"
          image="coding-girls-logo.png"
          link="https://codinggirls.sg/"
        />
        <Logo
          name="Girls in Tech"
          image="girls_in_tech_singapore_logo.png"
          link="https://girlsintech.org/"
        />
        <Logo
          name="She Loves Data"
          image="she-loves-data-logo.png"
          link="https://shelovesdata.com/"
        />
        <Logo
          name="Women Who Code"
          image="women_who_code_logo.png"
          link="https://www.womenwhocode.com/"
        />
        <Logo
          name="TechLadies"
          image="techladies_logo.png"
          link="http://www.techladies.co/"
        />
      </div> */}
      <h2>Supporting Partners</h2>
      <div className="row">
        <Logo
          name="AIESEC"
          image="aiesec_logo.png"
          link="https://www.facebook.com/AIESECSingapore/"
        />
        <Logo
          name="IEEE NTU Student Branch"
          image="ieee-ntu-logo.png"
          link="http://www.ieeentu.com/"
        />
        <Logo
          name="IEEE SUTD Student Branch"
          image="ieee-sutd-logo.png"
          link="https://sutd-ieee.github.io/"
        />
        <Logo
          name="Institute of Engineers Singapore Student Branch - SUTD"
          image="ies-sutd-student-logo.png"
          link="https://www.facebook.com/IES-SUTD-1554216541505233/"
        />
        <Logo
          name="Institution of Engineers Singapore NUS Student Chapter (IES-NUS)"
          image="ies-nus-logo.png"
          link="https://www.facebook.com/iesnus/"
        />
        <Logo
          name="NBS Business Analytics Club"
          image="nbs-nac-logo.png"
          link="http://clubs.ntu.edu.sg/businessanalytics/"
        />
        <Logo
          name="NTU CEE Graduate Students' Club"
          image="ntu-cee-gsc-logo.png"
          link="http://www.cee.ntu.edu.sg/Students/Graduate/ceegsc/Pages/Home.aspx"
        />
        <Logo
          name="NTU Institution of Engineering & Technology (IET)"
          image="IET Logo (Transparent Background).png"
          link="https://www.facebook.com/ietntuss/"
          className="ntu-iet"
        />
        <Logo
          name="NTU MLDA @ EEE"
          image="ntu-mlda-eee-logo.png"
          link="http://www.eee.ntu.edu.sg/programmes/mlda/Pages/Home.aspx"
        />
        <Logo name="NTU Women in Tech" image="ntu_women_in_tech.jpg" link="" />
        <Logo
          name="NUS Business Analytics Consulting Team"
          image="nus-bact-logo.png"
          link="https://nusbact.com/"
        />
        <Logo
          name="NUS Engineering Science Programme (ESP)"
          image="ESP.jpg"
          link="https://nusbact.com/"
          className="nus-esp"
        />
        <Logo
          name="NUS Industrial & Systems Engineering Club "
          image="nus-ise-club-logo.png"
          link="https://www.facebook.com/pg/NUSISEClub/about/?ref=page_internal"
        />

        <Logo
          name="NUS Statistics Society"
          image="nus-statistic-society-logo-2020.png"
          link="https://www.facebook.com/nus.statistics.soc/"
          className="nus-statistic-society"
        />
        <Logo
          name="NUS Student Engineering Club"
          image="NUS Student Engineering Club.png"
          link="http://enginclub.com/"
        />
        <Logo
          name="NUS Students' Computing Club"
          image="nus-students-computing-logo.png"
          link="https://nuscomputing.com/"
        />

        <Logo
          name="PINTU"
          image="LogoPINTU.jpg"
          link="https://pintusingapura.org/"
        />
        <Logo
          name="PINUS"
          image="pinus-logo.png"
          link="https://www.facebook.com/PerhimpunanIndonesiaNUS/"
        />
        <Logo
          name="SIT Institution of Engineers Singapore (IES)"
          image="sit-ies-logo.png"
          link="https://www.singaporetech.edu.sg/studentlife/clubs-and-committees/special-interest/institutional-engineering-singapore-ies"
        />
        <Logo
          name="SMU Chao Vietnam (SMU Vietnamese Student Society)"
          image="SMU Chao Vietnam Logo.png"
          link="https://www.facebook.com/SMU.VietnameseCommunity/"
          className="smu-chao-vietnam"
        />

        <Logo
          name="SMU EllipSIS"
          image="smu-ellipsis-logo.png"
          link="http://ellipsis.sis.smu.edu.sg/"
        />
        <Logo
          name="SMU Yim Siam (SMU Thai Student Society)"
          image="Thai_soc_sg_logo (1).jpg"
          link="https://m.facebook.com/ThaiStudentSocietySingapore/"
          className="smu-yim-siam"
        />
        <Logo
          name="SUTD Energy Club"
          image="SUTD Energy Club.jpg"
          link=""
          className="sutd-energy"
        />
        {/* <Logo name="Yale NUS " image="PENDING" link="" /> */}

        {/* 
        // behind last
        <Logo
          name=".NET Developers Community Singapore"
          image="dotnetsg-logo.png"
          link="https://www.meetup.com/NET-Developers-SG/"
        />
        <Logo
          name="ABEJA Singapore PteLtd"
          image="abeja-logo.png"
          link="https://abejainc.com/en/"
        />
        <Logo
          name="AI of Everything Singapore (AIOFES)"
          image="ai-everything-logo.png"
          link="https://www.meetup.com/AIOFES/"
        />
        
        <Logo
          name="ALPHA Camp"
          image="alpha-logo.png"
          link="https://sg.alphacamp.co/"
        />
        <Logo
          name="Asian Data Science"
          image="asian-data-science.png"
          link="https://www.facebook.com/AsianDataScience/"
        />
        <Logo
          name="Azure Community Singapore (ACS)"
          image="azure-community-logo.png"
          link="https://www.meetup.com/AzureSG/"
        />
        <Logo
          name="Augmented Artificial for Everyone Singapore (AAFES)"
          image="aafes-logo.png"
          link="https://www.meetup.com/AIFORES/"
        />
        <Logo
          name="Cloud Innovates Pte Ltd"
          image="cloud-innovates-logo.png"
          link="http://cloudinnovates.com/"
        />
        <Logo
          name="Code for Asia Society Ltd"
          image="code-for-asia-society-logo.png"
          link="https://codefor.asia/"
        />
        <Logo
          name="Code Gakko"
          image="code-gakko-logo.png"
          link="https://www.codegakko.com/"
        />
        <Logo
          name="Data Science Dojo Singapore"
          image="data-science-dojo-logo.png"
          link="https://datasciencedojo.com/"
        />
        <Logo
          name="DataScience SG"
          image="data-science-sg-logo.png"
          link="https://www.meetup.com/DataScience-SG-Singapore/"
        />
        <Logo
          name="Direct Sourcing Solutions (DSS)"
          image="dss-logo.png"
          link="https://dss.asia/"
        />
        <Logo
          name="General Assembly"
          image="general-assembly-logo.png"
          link="https://generalassemb.ly/"
        />
        <Logo
          name="GetLinks"
          image="getlinks-logo.png"
          link="https://getlinks.co/"
        />
        <Logo
          name="Hacks/Hackers Singapore"
          image="hacks-sg-logo.png"
          link="https://www.meetup.com/Hacks-Hackers-Singapore/"
        />
        <Logo
          name="Ideas Innovation Labs"
          image="ideas-innovation-labs-logo.png"
          link="http://ideaslabs.xyz/"
        />
        

        <Logo
          name="IES PSB Academy Student Chapter"
          image="ies-psb-logo.png"
          link="https://www.facebook.com/iespsbacademy/"
        />
        <Logo
          name="IET PSB Academy on Campus"
          image="iet-psb-logo.png"
          link="https://www.facebook.com/IET-PSB-Academy-On-Campus-337703010076320/"
        />
        
        <Logo
          name="impress.ai"
          image="impress-logo.png"
          link="https://impress.ai/"
        />

        <Logo
          name="Junction X"
          image="junctionx-logo.png"
          link="https://singapore.hackjunction.com/"
        />
        <Logo
          name="Lianna Pte Ltd"
          image="lianna-logo.png"
          link="https://lianna.sg/"
        />
        <Logo
          name="Lifelong Learning Institute"
          image="lifelong-logo.png"
          link="https://www.lli.sg/"
        />
        
        <Logo
          name="Next-Gen Analytics Mondays"
          image="next-gen-analytics-logo.png"
          link="https://www.meetup.com/Next-Gen-Analytics-Singapore/"
        />

        
        <Logo
          name="NTU Open Source Society"
          image="ntu-open-source-logo.png"
          link="https://ntuoss.com/home"
        />
        <Logo
          name="NUS BiZiT"
          image="nus-bizit-logo.png"
          link="https://www.facebook.com/bizitsociety/"
        />
        <Logo
          name="NUS Business Analytics Consulting Team"
          image="nus-bact-logo.png"
          link="https://nusbact.com/"
        />

        <Logo
          name="NUS Engineering Club"
          image="nus-students-engineering-logo.png"
          link="http://enginclub.com/"
        />
        <Logo
          name="NUS Entrepreneurship Society"
          image="nus-entrepreneurship-society-logo.png"
          link="https://www.nes.org.sg/"
        />
        <Logo
          name="NUS Fintech Society"
          image="nus-fintech-society-logo.png"
          link="https://www.fintechsociety.comp.nus.edu.sg/"
        />
        

        <Logo
          name="Nulab Singapore"
          image="nulab-logo.png"
          link="https://nulab.com/"
        />
        <Logo
          name="NuSpace Singapore"
          image="nuspace-singapore-logo.png"
          link="https://nuspace.nulab.com/"
        />
        <Logo
          name="Padang & Co"
          image="padang-co-logo.png"
          link="http://padang.co/"
        />
        <Logo
          name="PINUS"
          image="pinus-logo.png"
          link="https://www.pinusonline.com/"
        />
        <Logo
          name="PSB Academy’s SCS Student Chapter"
          image="psb-academy-logo.png"
          link="https://www.facebook.com/SCSPSB/"
        />
        <Logo
          name="PyData Singapore"
          image="pydata-singapore-logo.png"
          link="https://www.meetup.com/PyData-SG/"
        />
        <Logo
          name="Red Dot Innovation!"
          image="red-dot-innovation-logo.png"
          link="https://www.meetup.com/Red-Dot-Innovation/"
        />
        <Logo
          name="SG Code Campus"
          image="sgcc-logo.png"
          link="https://www.sgcodecampus.com/"
        />
        <Logo
          name="SGInnovate"
          image="sginnovate-logo.png"
          link="https://www.sginnovate.com/"
        />
        <Logo
          name="SIM Data Analysis Club"
          image="sim-data-analysis-logo.png"
          link="https://www.facebook.com/dacsim/"
        />
        <Logo
          name="SIM IT Club"
          image="simitc-logo.png"
          link="https://www.facebook.com/simitclub/"
        />
        <Logo
          name="SIM Young Entrepreneurs Network"
          image="sim-young-logo.png"
          link="https://www.sim-yen.com/"
        />
        <Logo
          name="Singapore Data Science Academy"
          image="singapore-data-science-academy-logo.png"
          link="https://www.sdsa.sg/"
        />
        <Logo
          name="Singapore iOS Dev Scout"
          image="singapore-ios-dev-scou-logo.png"
          link="https://www.meetup.com/Singapore-iOS-Dev-Scout-Meetup/"
        />
        <Logo
          name="GoSG"
          image="go-sg-logo.png"
          link="https://www.meetup.com/golangsg/"
        />
        <Logo
          name="Singapore Python User Group (PUGS) "
          image="pugs-logo.png"
          link="http://pugs.org.sg/"
        />
        <Logo
          name="SIT Geeks"
          image="sit-geeks-logo.png"
          link="https://www.facebook.com/groups/sitgeeks/"
        />

        <Logo
          name="Sparkline"
          image="sparkline-logo.png"
          link="https://www.sparkline.com/"
        />
        <Logo
          name="SUTD Data Science & Analytics Consulting Club"
          image="sutd-data-science-logo.png"
          link=""
        />
        <Logo
          name="Tech Talent Assembly"
          image="ttab-logo.png"
          link="http://www.ttab.org.sg/Pages/Home.aspx"
        />
        <Logo
          name="TechNode"
          image="technode-logo.png"
          link="https://technode.com/"
        />
        <Logo
          name="The Brainery Code"
          image="the-brainery-code-logo.png"
          link="https://www.thebrainerycode.com/"
        />
        <Logo
          name="Tinkertanker"
          image="tinkertanker-logo.png"
          link="https://tinkercademy.com/"
        />
        <Logo
          name="Viz.sg"
          image="vizsg-logo.png"
          link="https://www.meetup.com/Data-Vis-Singapore/"
        />
        <Logo
          name="Wanted"
          image="wanted_logo.png"
          link="https://www.wanted.jobs/"
        />
        <Logo
          name="why innovation!"
          image="why-innovation-logo.png"
          link="https://www.why-innovation.com/"
        /> */}
      </div>
    </div>
  </section>
);

export default Partners;
